import React from 'react';
import { Spinner } from 'react-bootstrap';

export default function AppLoading() {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
      <div className="text-center">
        <Spinner animation="border" role="status" variant="danger">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-3 fw-bold text-danger">LOADING...PLEASE WAIT</p>
      </div>
    </div>
  );
}
